<template>
  <div class="search-input-box" :class="{ simple: !searchMode ,short: activeLocal }">
    <el-autocomplete
      ref="searchInput"
      v-model="activeLocal"
      value-key="name"
      size="small"
      prefix-icon="el-icon-search"
      class="search-input"
      popper-class="search-input-popper"
      :placeholder="searchMode ? '名称 / GO' : ''"
      clearable
      :fetch-suggestions="querySearch"
      @click.native="enterSearchMode"
      @blur="exitSearchMode"
      @select="handleSelect"
    >
      <div
        class="pop-item-click"
        slot-scope="{ item }"
        @mouseenter="handleStop"
        @mouseleave="handleStart"
      >
        <div class="name text-white">{{ item.name }}</div>
        <span class="addr text-white font-sm" style="color: #999999;">{{ item.go }}</span>
      </div>
    </el-autocomplete>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    arr: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    //支持搜索的设备
    searchArr() {
      return this.arr
    },
  },
  data() {
    return {
      searchMode: false,
      activeLocal: "",
      itemClick: false,
    };
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleTabVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleTabVisibilityChange);
  },
  methods: {
    querySearch(queryString, cb) {
      var items = this.searchArr;
      var results = queryString
        ? items.filter(this.createFilter(queryString))
        : items;
      // 调用 callback 返回建议列表的数据
      cb(results.slice(0, 9));
    },
    createFilter(queryString) {
      return (item) => {
        return (
          item.go.toLowerCase().indexOf(queryString.toLowerCase()) > -1 ||
          item.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },
    handleSelect(val) {
      this.itemClick = false;
      this.$emit("select", val);
      this.activeLocal = "";
      this.itemClick = false;
      this.searchMode = false;
    },
    handleFocus() {
      this.$emit("focus");
    },
    enterSearchMode() {
      if (!this.searchMode) {
        this.searchMode = true;
        this.$nextTick(() => {
          this.$refs["searchInput"].focus();
        });
      }
    },

    exitSearchMode(e) {
      if (!this.activeLocal && !this.itemClick) {
        this.searchMode = false;
        this.itemClick = false;
        this.$refs["searchInput"].close();
      }
    },

    handleStop() {
      this.itemClick = true;
    },

    handleStart() {
      this.itemClick = false;
    },

    handleTabVisibilityChange() {
      if (document.visibilityState === "hidden") {
        this.$refs.searchInput.$refs.input.blur();
      }
    },
  },
};
</script>

<style lang="scss">
.search-input-box {
  position: relative;
  height: 34px;
  border: 1px solid #999;
  border-radius: 17px;
  width: 100%;
  // transition: width .1s;
  overflow: hidden;
  &.simple {
    width: 34px;
    transition: width 0.5s;
  }
  .search-input {
    border-width: 0;
    width: 238px;
    border-radius: 16px;
    .el-input {
      width: auto;
    }
    .el-input__inner {
      width: 238px;
      border-width: 0;
      color: #fff;
      background-color: transparent;
      &::-webkit-input-placeholder {
        color: #999;
      }
    }
    .el-input__prefix {
      color: #999;
      left: 4px;
    }
  }
}
.search-input-popper {
  background-color: #252a2f;
  border-width: 0;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.18);
  &.el-popper[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: #252a2f;
  }
  &.el-popper[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: #252a2f;
  }
  ul li:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  ul li {
    padding: 0;
    line-height: 18px;
    &:nth-child(1) .pop-item-click {
      border-top: 1px solid rgba(128, 128, 128, 0.3);
    }
    .pop-item-click {
      padding: 8px 20px;
      border-bottom: 1px solid rgba(128, 128, 128, 0.3);
    }
  }
}
</style>
